import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class RegionGroups extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                sortable: true,
                Cell: ({ value, row: { original } }) => {
                    return <Link to={paths.regionGroupsShow(original.id)}>{value}</Link>;
                },
            },
        ];
    }

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;

        const action = () => {
            return modal({
                name: "createRegionGroup",
                title: "Создание группы регионов",
                windowMod: "wide",
                mergeParams,
            });
        };

        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Создать группу регионов
            </a>
        );
    };
}

export default tableContainer(RegionGroups, "region-groups");
